import type { Localized } from "../types/i18n";

export type Validator = (value: string) => Localized | null;

export const required: Validator = (value) =>
  value.trim() ? null : { en: "This field is required.", es: "Este campo es obligatorio." };

export const email: Validator = (value) => {
  if (!value.trim()) return required(value);
  return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value.trim())
    ? null
    : { en: "Enter a valid email address.", es: "Ingrese un correo electrónico válido." };
};

export const phone: Validator = (value) => {
  if (!value.trim()) return required(value);
  const digits = value.replace(/\D/g, "");
  return digits.length >= 10 && digits.length <= 15
    ? null
    : { en: "Enter a valid phone number.", es: "Ingrese un número de teléfono válido." };
};
